export enum NodeTypes {
    group = 'group',
    section = 'section',
    root = 'root',
}

export enum ExcludePaginationNodeTypes {
    group = 'group',
    root = 'root',
    Root = 'Root',
    QuestionSet = 'QuestionSet',
    FormRow = 'FormRow',
}

export enum Tabs {
    Patient = 'patient',
    Questionnaire = 'questionnaire',
}

export enum alerts {
    alerts = 'Alert',
    action = 'Action',
}

export enum WaitingListRecordStatuses {
    Initial = 1,// Shown on triage list , Not removed, done trak status
    POA = 2, /// Shown on POA List
    Complete = 3,/// Shown on POA List
    Expired = 4 /// Shown on POA List
}

export enum POATypes {
    PhoneCall = 1,
    FaceToFace = 2,
}

export enum ListTypes {
    TriageList = "TriageList",
    PoaList = "POAList"
}

export enum QuestionnaireResponseStatus {
    Sent = 1,
    Started = 2, 
    PatientCompleted = 3,
    POA = 4,
    Complete = 5,
    Expired = 6
}